import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-arrow--up",
  "use": "icon-arrow--up-usage",
  "viewBox": "0 0 14 16",
  "content": "<symbol fill=\"none\" xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 14 16\" id=\"icon-arrow--up\"><path d=\"M0 7.228a.804.804 0 0 0 .523.714.782.782 0 0 0 .852-.215l4.428-4.875.001 12.721c0 .028-.002-.759 0-.731.02.418.417.779.83.757.414-.022.771-.422.75-.84V2.852l4.42 4.875a.79.79 0 0 0 .87.241.788.788 0 0 0 .457-.426.805.805 0 0 0-.168-.896L7.17.256A.79.79 0 0 0 6.59 0a.783.783 0 0 0-.58.257L.215 6.646A.8.8 0 0 0 0 7.228Z\" fill=\"currentcolor\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol